import { render, staticRenderFns } from "./SolicitacaoInventarioForm.vue?vue&type=template&id=239f5510"
import script from "./SolicitacaoInventarioForm.vue?vue&type=script&lang=js"
export * from "./SolicitacaoInventarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports